module.exports = __webpack_public_path__ + "img/icon-progress.2ba3dc8c.svg";